export const regimeTributarioOptions = [
    {label: 'Simples nacional', value: 'sn'},
    {label: 'Lucro real', value: 'lr'},
    {label: 'Lucro presumido', value: 'lp'}
];